import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { TranslateService } from '@ngx-translate/core';
import { ColumnSelectComponent } from '../column-select/column-select.component';

@Component({
  selector: 'app-daily-reg',
  templateUrl: './daily-reg.component.html',
  styleUrls: ['./daily-reg.component.css']
})
export class DailyRegComponent implements OnInit {

  public menu_item_id = '123';

  branchList = [];
  users = [];

  private dp = [];
  displayedColumns = ['sr', 'invoice_no', 'invoice_date', 'trip_name', 'customer_name', 'mobile', 
    'final_total', 'branch_name', 'reg_status', 'inv_status', 'paid_amount', 'remain_amount', 
    'total_cost', 'total_profit', 'created_by']; 

  // displayedColumns2 = ['sr', 'invoice_no', 'invoice_date', 'trip_name', 'customer_name', 'customer_name_en', 
  //   'mobile', 'final_total', 'branch_name', 'reg_status', 'inv_status', 'paid_amount', 'remain_amount', 
  //   'total_cost', 'created_by'];

  model = {
    'invoice_no': '', 'customer_name': '', 'mobile': '', 'trip_name': '', 'trip_number': '',
    'title': 'قائمة الفواتير', 'reg_from_date': new Date(), 'reg_to_date': new Date(),
    'dep_from_date': new Date(), 'dep_to_date': new Date(), 'trip_id': '0', 'type_id': 'all', 
    'branch_id' : '0', 'depart_flight_id': '0', 'return_flight_id': '0', 'user_name': 'all'
  };

  search_prog = {
    'placeholder': 'اسم البرنامج/ رقم البرنامج', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`trip`', 'selected_no': 'trip_id',
      'field_list': ['trip_name', 'trip_number']
    }]
  };

  search_flight = {
    'placeholder': 'اسم رحلة الطيران/ رقم رحلة الطيران', 'class_name': 'midField',
    'table_list': [{
      'table_name': '`flight`', 'selected_no': 'flight_id',
      'field_list': ['flight_name', 'flight_number', 'flight_date']
    }]
  };

  type_list = [
    { 'type_id': 'all', 'type_name': 'الكل', 'type_name_en': 'All' },
    { 'type_id': 'program', 'type_name': 'عقود البرامج السياحية', 'type_name_en': 'Tourism Programs Contracts' },
    { 'type_id': 'special_prog', 'type_name': 'عقود البرامج الخاصة', 'type_name_en': 'Special Programs Contracts' },
    { 'type_id': 'flight', 'type_name': 'عقود رحلات الطيران', 'type_name_en': 'Flight Contracts' },
    { 'type_id': 'flight_block', 'type_name': 'عقود بلوكات الطيران', 'type_name_en': 'Flight Blocks Contracts' }
  ];

  dialog_data = [{ 'id': 'sr', 'title_ar': 'الرقم', 'title_en': 'Number', 'checked': '1' },
    { 'id': 'invoice_no', 'title_ar': 'رقم العقد/ الفاتورة', 'title_en': 'Contract/ Invoice Number', 'checked': '1' },
    { 'id': 'invoice_date', 'title_ar': 'التاريخ', 'title_en': 'Date', 'checked': '1' },
    { 'id': 'trip_name', 'title_ar': 'اسم البرنامج', 'title_en': 'Program Name', 'checked': '1' },
    { 'id': 'customer_name', 'title_ar': 'اسم المسافر', 'title_en': 'Traveler Name', 'checked': '1' },
    { 'id': 'customer_name_en', 'title_ar': 'الاسم الإنجليزي', 'title_en': 'English Name', 'checked': '0' },
    { 'id': 'mobile', 'title_ar': 'رقم الجوال', 'title_en': 'Mobile', 'checked': '1' },
    { 'id': 'final_total', 'title_ar': 'مبلغ العقد/ الفاتورة', 'title_en': 'Contract/ Invoice Total', 'checked': '1' }, 
    { 'id': 'branch_name', 'title_ar': 'الفرع', 'title_en': 'Branch', 'checked': '1' },
    { 'id': 'reg_status', 'title_ar': 'حالة الدفع', 'title_en': 'Payment Status', 'checked': '1' },
    { 'id': 'inv_status', 'title_ar': 'الحالة', 'title_en': 'Status', 'checked': '1' },
    { 'id': 'paid_amount', 'title_ar': 'المدفوع', 'title_en': 'Paid', 'checked': '1' },
    { 'id': 'remain_amount', 'title_ar': 'المتبقي', 'title_en': 'Remaining', 'checked': '1' },
    { 'id': 'total_cost', 'title_ar': 'مجموع التكلفة', 'title_en': 'Total Cost', 'checked': '1' },
    { 'id': 'total_profit', 'title_ar': 'الربح', 'title_en': 'Profit', 'checked': '1' },
    { 'id': 'created_by', 'title_ar': 'مدخل البيانات', 'title_en': 'Data Entry', 'checked': '1' }
  ];

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;
  colDialogRef: MatDialogRef<ColumnSelectComponent>;

  Daily_Reg_Rep; Program_Placeholder; Search_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Daily_Reg_Rep').subscribe((res: string) => {
      this.Daily_Reg_Rep = res;
    });
    this.model['title'] = this.Daily_Reg_Rep;

    translate.get('Program_Placeholder').subscribe((res: string) => {
      this.Program_Placeholder = res;
    });
    this.search_prog.placeholder = this.Program_Placeholder;

    translate.get('Search_Msg').subscribe((res: string) => {
      this.Search_Msg = res;
    });

  }

  ngOnInit() {

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });

    this.model['dep_from_date'] = undefined;
    this.model['dep_to_date'] = undefined;

    let condition = '';
    if (this.applicationConstants.user_info['user_name'] != 'mas')
      condition += " AND `user`.`user_name` != 'mas'";

    query = "SELECT `user`.`user_id`, `employee`.`name`, `employee`.`name_en`, `user`.`user_name`, `employee`.`employee_no`" +
      " FROM `user`, `employee` WHERE `user`.`status` = '1' AND `employee`.`employee_no` = `user`.`employee_no`" + condition;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        
        this.users = data.data['list'];
        this.users.unshift({ 'user_name': 'all', 'name': 'الكل', 'name_en': 'All' });
      });
  }

  onChangeProg = function (search_result: object) {
    this.model['trip_id'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeDepartFlight = function (search_result: object) {
    this.model['depart_flight_id'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeReturnFlight = function (search_result: object) {
    this.model['return_flight_id'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  search() {
    if (this.model['invoice_no'] == '' && this.model['customer_name'] == '' && this.model['mobile'] == '' &&
      this.model['reg_from_date'] == undefined && this.model['reg_to_date'] == undefined &&
      this.model['dep_from_date'] == undefined && this.model['dep_to_date'] == undefined && 
      (this.model['type_id'] == 'all' || this.model['type_id'] == 'special_prog' || 
      (this.model['type_id'] == 'program' && this.model['trip_id'] == '0') || 
      ((this.model['type_id'] == 'flight' || this.model['type_id'] == 'flight_block') && 
      this.model['depart_flight_id'] == '0' && this.model['return_flight_id'] == '0'))) {

      alert(this.Search_Msg);
      return;
    }

    let obj = { cmd: 'getContractList' };

    if (this.model['invoice_no'] != '') {
      obj['invoice_no'] = this.model['invoice_no'];
    }
    else {
      if (this.model['customer_name'] != '')
        obj['customer_name'] = this.model['customer_name'];

      if (this.model['mobile'] != '')
        obj['mobile'] = this.model['mobile'];

      obj['type_id'] = this.model['type_id'];
      if (this.model['type_id'] == 'program' && this.model['trip_id'] != '0')
        obj['trip_id'] = this.model['trip_id'];

      if (this.model['type_id'] == 'flight' && this.model['flight_id'] != '0')
        obj['flight_id'] = this.model['flight_id'];

      if (this.model['reg_from_date'] != undefined)
        obj['reg_from_date'] = this.model['reg_from_date'].getFullYear() + "-" + (this.model['reg_from_date'].getMonth() + 1) + "-" +
          this.model['reg_from_date'].getDate() + " 00:00:00";

      if (this.model['reg_to_date'] != undefined)
        obj['reg_to_date'] = this.model['reg_to_date'].getFullYear() + "-" + (this.model['reg_to_date'].getMonth() + 1) + "-" +
          this.model['reg_to_date'].getDate() + " 23:59:59";

      if (this.model['dep_from_date'] != undefined)
        obj['dep_from_date'] = this.model['dep_from_date'].getFullYear() + "-" + (this.model['dep_from_date'].getMonth() + 1) + "-" +
          this.model['dep_from_date'].getDate();

      if (this.model['dep_to_date'] != undefined)
        obj['dep_to_date'] = this.model['dep_to_date'].getFullYear() + "-" + (this.model['dep_to_date'].getMonth() + 1) + "-" +
          this.model['dep_to_date'].getDate();

      if (this.model['user_name'] != 'all')
        obj['user_name'] = this.model['user_name'];
    }

    if (this.model['branch_id'] != '0')
      obj['branch_id'] = this.model['branch_id'];
    else {
      if (this.branchList.length == 2) 
        obj['branch_id'] = this.branchList[1]['branch_id'];
      else {
        let branch_list = [];
        this.branchList.forEach(element => {
          if (element.branch_id != '0')
            branch_list.push({ 'branch_id': element.branch_id });
        });
        obj['branch_list'] = branch_list;
      }
    }
    obj['calculate_cost'] = '1';

    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        console.log(data);

        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  column_select() {
    this.colDialogRef = this.dialog.open(ColumnSelectComponent, {
      hasBackdrop: false,
      data: this.dialog_data
    });
    this.colDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != undefined) {
          console.log(result);
          this.dialog_data = result;
          this.displayedColumns = [];
          // this.displayedColumns2 = [];

          this.dialog_data.forEach(element => {
            if (element.checked == '1') {
              this.displayedColumns.push(element.id);
              // this.displayedColumns2.push(element.id);
            }
          });
        }
      });
  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.Daily_Reg_Rep + '</td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('invoice_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }
}
